var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contract-documents" },
    [
      _c("section-title", {
        staticClass: "mt-4 mb-3",
        attrs: {
          "has-line": "",
          title: "Documentos Contrato",
          "title-class": "section-title-info"
        }
      }),
      _vm._l(_vm.page.data, function(contract, idx) {
        return _c(
          "div",
          { key: idx },
          [
            _c("contract-document-container", {
              attrs: {
                "contract-document": contract,
                "proposal-request-id": _vm.proposalRequestId,
                "show-submit": _vm.showSubmit
              },
              on: {
                "on-file-upload": _vm.searchDocuments,
                "on-status-change": _vm.onStatusChangeHandler
              }
            })
          ],
          1
        )
      }),
      _vm.page.totalItemCount > _vm.pageSize
        ? _c("pagination", {
            attrs: { data: _vm.page, "page-size": _vm.pageSize },
            on: { "pagination-go-page": _vm.setCurrentPage }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }